import { Api } from '@/api/api.client';
import { uploadFile } from '@/api/resources/file.api';
import { FileUploadType } from '@/api/generated/api.enum';
import { WHO_AM_I_QUERY_KEY } from '@/api/query.keys';
import { useQueryClient } from '@tanstack/vue-query';

interface IAvatarPicturesComposable {
  uploadUserAvatarPicture: (file: File) => Promise<void>;
}

/**
 * User avatar picture uploads. Every upload mints a new file id on the
 * backend (rendered via useFileImage), so invalidating the owning query is enough to refresh the displayed
 * picture immediately, no cache-busting needed.
 */
export function useAvatarPictures(): IAvatarPicturesComposable {
  const queryClient = useQueryClient();

  async function uploadUserAvatarPicture(file: File): Promise<void> {
    const uploaded = await uploadFile(FileUploadType.userAvatar, file);
    await Api.Routes.AvatarPicture.setMyAvatarPicture(null, { fileId: uploaded.id });
    await queryClient.invalidateQueries({ queryKey: WHO_AM_I_QUERY_KEY });
  }

  return {
    uploadUserAvatarPicture,
  };
}
